// CONNECT HR Dashboard - Authentication Configuration
// This app requires a SEPARATE Entra ID App Registration from the main CONNECT Portal

export const msalConfig = {
  auth: {
    // TODO: Replace with your HR Dashboard App Registration Client ID
    clientId: 'dd7e4cce-cab8-4503-b89e-fb0c6cf213a9',
    authority: 'https://login.microsoftonline.com/ea8f9616-c989-4b89-89a9-0a33ed0e3d32',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    'User.Read',
    'Sites.ReadWrite.All',
    'Files.ReadWrite.All',
  ],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
